import {Box, Typography, useTheme} from '@mui/material';
import type {Theme} from '@mui/material/styles';

type ProProps = {
  bgColor: string;
};
const Pro = ({bgColor}: ProProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: bgColor,
        borderRadius: theme.spacing(0.5),
        width: theme.spacing(3.625),
        height: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        color="white"
        fontSize={theme.typography.pxToRem(12)}
        fontWeight={theme.typography.fontWeightMedium}
        // py={theme.spacing(0.25)}
        px={theme.spacing(0.5)}
      >
        Pro
      </Typography>
    </Box>
  );
};

export default Pro;
